export default "__VITE_ASSET__CXMsasC7__"